
import { useContext } from 'react'
import GlobalStateContext from '../context/GlobalStateContext'

export const useGlobalState = () => {
  
  const { state, dispatch } = useContext(GlobalStateContext)
  return {
    ...state,
    dispatch
  }
}